import eventEmitter from "@/utils/emitter.js";

const TokenKey = 'token'
const localLang = 'localLang'

export function getToken() {
    return localStorage.getItem(TokenKey)
}

export function setToken(token) {
    return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
    return localStorage.removeItem(TokenKey)
}

export function getLang() {
    return localStorage.getItem(localLang)
}

//登录后是否弹充值返利弹框
export function showRechargeRebateModal(u, $api, handleResponse, show = false) {
    console.log('showRechargeRebateModal');

    if (!u.isToken) {
        return;
    }
    //登录成功后请求查看返利接口,用来处理是否充值返利弹框
    $api.user.getCheckRebate().then(res => {
        const resp = handleResponse(res);
        if (!resp) return console.log("未知错误", res.message);
        console.log('返利resp:', resp);
        if (show) {
            eventEmitter.emit('api:showRechargeRebateModal', resp)
            return;
        }
        if (resp.is_use === 'y') {
            eventEmitter.emit('api:showRechargeRebateModal', resp)
        }
    })
}